export const formatFileSize = (size: number): string => {
  if (size >= 1073741824) {
    // GB
    return (size / 1073741824).toFixed(2) + ' GB';
  } else if (size >= 1048576) {
    // MB
    return (size / 1048576).toFixed(2) + ' MB';
  } else if (size >= 1024) {
    // KB
    return (size / 1024).toFixed(2) + ' KB';
  } else {
    // Bytes
    return size + ' Bytes';
  }
};

export const compactFileName = (name: string, maxLength: number = 15): string => {
  if (name.length <= maxLength) return name;

  const extensionIndex = name.lastIndexOf('.');
  const extension = name.slice(extensionIndex);
  const baseName = name.slice(0, extensionIndex);

  const start = baseName.slice(0, 4);
  const end = baseName.slice(-6);
  return `${start}...${end}${extension}`;
};